'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoIssueReopened = function GoIssueReopened(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 30c-2.1 1.5-4.7 2.5-7.5 2.5-6.9 0-12.5-5.6-12.5-12.5 0-1.8 0.4-3.5 1.1-5h-3.6v-3.9c-1.5 2.6-2.5 5.6-2.5 8.9 0 9.7 7.8 17.5 17.5 17.5 4.2 0 8-1.5 11-4l1.5 1.5v-7.5h-7.5l2.5 2.5z m-10 0h5v-5h-5v5z m5-20h-5v12.5h5v-12.5z m15 10c0-9.7-7.8-17.5-17.5-17.5-4.2 0-8 1.5-11 4l-1.5-1.5v7.5h7.5l-2.5-2.5c2.1-1.5 4.7-2.5 7.5-2.5 6.9 0 12.5 5.6 12.5 12.5 0 1.8-0.4 3.5-1.1 5h3.6v3.9c1.5-2.6 2.5-5.6 2.5-8.9z' })
        )
    );
};

exports.default = GoIssueReopened;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/issue-reopened.js
// module id = 1942
// module chunks = 0